import React, { useEffect, useState } from 'react';
import {
    Grid, ArgumentAxis, Chart, Series, CommonSeriesSettings, Legend,
    ValueAxis, Export, Tooltip, Title, Subtitle, Margin
} from 'devextreme-react/chart';
import useApi from '../../hooks/useApi';
import uri from '../../utils/uri';
import { SelectBox } from 'devextreme-react';
import useLocalStorage from '../../hooks/useLocalStorage';
import { formatToMoneyNumber } from '../../utils/common';
import PopupTopBestClients from './PopupTopBestClients';

const TopBestClients = () => {

    const { itemState, setItem } = useLocalStorage();
    
    const [open, setOpen] = useState(false);
    const [ topClients ] = useState([ 5, 10, 15, 20 ]);
    const [ topClientSelected, setTopClientSelected ] = useState(itemState.top || topClients[0]);

    const [ months ] = useState([ 
        { value: 1, text: 'Último Mes' },
        { value: 3, text: 'Últimos 3 Meses' },
        { value: 6, text: 'Últimos 6 Meses' },
        { value: 12, text: 'Últimos 12 Meses' }
    ]);
    const [ monthSelected, setMonthSelected ] = useState(itemState.lastMonth || months[0].value);

    const { data } = useApi({ url: uri.dashboard.base + '/get-clients-top?lastMonth=' + monthSelected + '&top=' + topClientSelected });  

    function contentRender(arg) {

        const { clientName, ventaContado, ventaCredito } = arg.point.data;
        const total = ventaContado + ventaCredito;

        return <div>
            <div>{clientName}</div>
            <div>Contado: {formatToMoneyNumber(ventaContado)}</div>
            <div>Credito: {formatToMoneyNumber(ventaCredito)}</div>
            <div>Total: <b>{formatToMoneyNumber(total)}</b></div>
        </div>
        // return {
        //     text: `${arg.seriesName} years: ${arg.valueText}`,
        // };
    }

    const setTopClient = (value) => {
        setTopClientSelected(value);
        setItem({ ...itemState, top: value });
    }

    const setMonth = (value) => {
        setMonthSelected(value);
        setItem({ ...itemState, lastMonth: value });
    }

    return (
        <div>
            <Chart
                id="chart"
                title="Top Mejores Clientes"
                dataSource={data}
            >
                <CommonSeriesSettings
                    argumentField="clientName"
                    type="stackedbar"
                    barWidth={50}
                    showInLegend={true}
                />
                <Series
                    valueField="ventaContado"
                    name="Venta Contado"
                />
                <Series
                    valueField="ventaCredito"
                    name="Venta Credito"
                />
                <ValueAxis position="right">
                    <Title text="Ventas" />
                </ValueAxis>
                <Legend
                    verticalAlignment="top"
                    horizontalAlignment="center"
                    itemTextPosition="top"
                />
                <Export enabled={true} />
                <Tooltip
                    enabled={true}
                    location="edge"
                    contentRender={contentRender}

                />
            </Chart>
            <div className="options">                
                <div className="common">
                    <div className="d-flex">                      
                        <div className="option">
                            <span>Top clientes:</span>
                            <SelectBox
                                dataSource={topClients}
                                defaultValue={topClients[0]}
                                value={topClientSelected}
                                onValueChanged={(e) => setTopClient(e.value)}
                            />
                        </div>
                        <div className="option">
                            <span>Rango:</span>
                            <SelectBox
                                dataSource={months}
                                defaultValue={monthSelected}
                                value={monthSelected}
                                valueExpr="value"
                                displayExpr="text"
                                onValueChanged={(e) => setMonth(e.value)}
                            />
                        </div>
                        <div className="option pt-24">
                            <PopupTopBestClients open={open} setOpen={setOpen} data={data} onClick={e => setOpen(true)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopBestClients;
